import React from 'react'
import { Button } from '@mc/design-system'
import { trackNavClick } from '@mc/global-navigation'
import { useTranslation } from '@mc/i18n'
import { paths } from '@mc/paths'
import { Locations, NavigationEvents } from '@mc/track-event'
import { CORE_NAV_PROMO_SIGNAL_I18N_NAMESPACE } from '../i18n'

export const CertsPromoCard = ({
  title,
  subtitle,
  product,
}: {
  title: string
  subtitle: string
  product?: string
}) => {
  const { t } = useTranslation(CORE_NAV_PROMO_SIGNAL_I18N_NAMESPACE)
  const cta = t('promoCard.cta')

  return (
    <div className='d-flex flex-column align-items-center mc-text--center mc-py-4'>
      <h4 className='mc-text-h5'>{title}</h4>
      <p className='mc-my-6' style={{ maxWidth: '300px' }}>
        {subtitle}
      </p>
      {/* Product decision: keep /certificates href also for the certificates page
        https://ourmasterclass.slack.com/archives/C07FR4LKCTD/p1787846001423039
        Fires the same Navigation Clicked event as the Browse All Certificates row.
          */}
      <Button
        fullWidth
        style={{ maxWidth: '300px' }}
        render={<a href={paths.certificates} />}
        onClick={(e: React.MouseEvent) => {
          e.stopPropagation()
          trackNavClick(
            cta,
            NavigationEvents.LEVELS.TERTIARY,
            Locations.NAVIGATION_PROMO_CERTS,
            product,
          )()
        }}
      >
        {cta}
      </Button>
      <p className='mc-text-small mc-opacity--muted mc-mt-3 mc-mb-0'>
        {t('promoCard.guarantee')}
      </p>
    </div>
  )
}
